import React, { use } from 'react'
import { useState, useEffect } from 'react'
import CargoService from "../../../../services/Cargo";
import { useNavigate } from 'react-router';
import Fcard from "./modal/Fcard";
import { useDispatch } from 'react-redux';
// import { showToast } from '../../../redux/slices/toastSlice';
import EmptyStateMyLoads from '../../../../Modals/empty list/EmptyList';
import DriverService from '../../../../services/Driver';
import AllCargoSkeleton from '../../../../pages/dashboard/favorites/FavoritesSkeleton';

const AllCargo = () => {
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false);

    //get all cargos
    async function getAllCargo() {
        setLoading(true);
        try {

            const res = await DriverService.getAllFavorites()
            setAllCarogs(res?.data?.data)

        } catch (err) {
            console.log(err)
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllCargo()
    }, [])

    const [allCargos, setAllCarogs] = useState([])
    const navigate = useNavigate()

    if (loading) {
        return (
                <AllCargoSkeleton />
        )
    }

    return (
        <>
            {

                allCargos?.length == 0 ?
                    <EmptyStateMyLoads

                        colorContent="text-special"
                        title="لیست علاقه مندی خالی است"
                        subtitle="تاکنون باری را ذخیره نکرده اید."
                        onCta={() => { navigate("/cargo") }}
                        ctaText="مشاهده لیست بار ها"
                    />

                    :
                    <div className="flex flex-col items-start justify-start  w-full lg:h-[calc(100vh-10rem)] overflow-y-auto ">

                        <Fcard cargos={allCargos}></Fcard>

                    </div>
            }

        </>
    )
}

export default AllCargo
